import { getPost } from '@src/model/upvote/helpers';
import { jotaiStore } from '@src/store/store';

export const isReactedToPost = (userId: string, postId: string, reactionName: string) => {
    const post = getPost(postId);
    if (!post || !post.reactionsUsers) return false;

    const reactionList = post.reactionsUsers[reactionName] || [];
    return reactionList.includes(userId);
};

export const getPostReactionCount = (postId: string, reactionName: string) => {
    const post = getPost(postId);
    if (!post) return 0;
    if (!post.reactionsCount) return 0;

    return post.reactionsCount[reactionName] || 0;
};

// Finds the name of the reaction a user has on a post, or null if none.
export const findUserReaction = (userId: string, postId: string) => {
    const post = getPost(postId);
    if (!post || !post.reactionsUsers) return false;

    for (const reactionName in post.reactionsUsers) {
        if (post.reactionsUsers[reactionName]?.includes(userId))
            return reactionName;

    }
    return null;
}
